module.exports = __webpack_public_path__ + "static/media/hello_img_4.b8b37bc1.png";